import "./accounts.scss";

const Accounts = () => {
  return (
    <div className="accounts">
      <h1>Billing</h1>
      </div>
  )
}

export default Accounts